import { useCallback } from 'react'

/** @param {{ setPinLimitDialogOpen: Function }} m */
export function usePinLimitDialogActions(m) {
  const closePinLimitDialog = useCallback(() => {
    m.setPinLimitDialogOpen(false)
  }, [m.setPinLimitDialogOpen])

  return { closePinLimitDialog }
}
